import { useState } from 'react';
import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton, MessageBar, MessageBarType } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { ChatExchange } from '../../components/ChatExchange';
import { userAPI } from '../../UserAPI';
import { useAtom } from 'jotai';
import { authenticationAtom } from '../../State';

interface UseTestDialogProps {
    onOrder?: (marketplaceOffer: any) => void;
}

export function useTestDialog({ onOrder }: UseTestDialogProps = {}) {
    const { t } = useTranslation();
    const [authentication] = useAtom(authenticationAtom) as any;
    const [isOpen, setIsOpen] = useState(false);
    const [selectedMarketplaceOffer, setSelectedMarketplaceOffer] = useState<any>(null);
    const [conversation, setConversation] = useState<any>({ messages: [] });

    const openTestDialog = async (marketplaceOffer: any) => {
        setSelectedMarketplaceOffer(marketplaceOffer);
        const newConversation = await userAPI.createConversation(authentication.customer);
        setConversation(newConversation);
        setIsOpen(true);
    };

    const closeTestDialog = () => {
        setIsOpen(false);
    };

    const TestDialog = () => (
        <Dialog
            hidden={!isOpen}
            onDismiss={closeTestDialog}
            maxWidth={1000}
            minWidth={1000}
            dialogContentProps={{
                type: DialogType.normal,
                title: t('settingsPanel.agentPanel.testDialog.title'),
            }}
            modalProps={{
                isBlocking: true,
            }}
        >
            <MessageBar className='marginTopL marginBottomL'
                messageBarType={MessageBarType.info}>
                {t('settingsPanel.agentPanel.testDialog.description')}
            </MessageBar>
            <div className='marginTopM displayFlex flexDirectionColumn' style={{ minHeight: '500px', maxHeight: '500px' }}>
                <ChatExchange
                    conversation={conversation}
                    showSuggestions={false}
                    showLogo={false}
                />
            </div>
            <DialogFooter className="marginTopXXL">
                {onOrder &&
                    <PrimaryButton onClick={() => {
                        closeTestDialog();
                        onOrder(selectedMarketplaceOffer);
                    }} text={t('settingsPanel.agentPanel.order')} />
                }
                <DefaultButton onClick={closeTestDialog} text={t('global.close')} />
            </DialogFooter>
        </Dialog>
    );

    return {
        TestDialog,
        openTestDialog,
        closeTestDialog
    };
} 